import consts from "@/consts";
import { RecordInitiator } from "@/types";
import { RTPace, RTFiller } from "@/types/LearnerRecordings";

// const authtoken = consts.devjwt;
const stopMsg = {
  CommandType: "FinishStreaming",
};

const cancelMsg = {
  CommandType: "CancelStreaming",
};

type ResultsCallBack = (results: any) => any;

export default class SocketHandler {
  public onWebRTCMessage?: Function;
  private ws!: WebSocket;
  private resultsCallback!: ResultsCallBack;
  private socketResponseInitiator!: any;
  private initiatorResolve: any;
  private onErrorCallback!: any;
  private initiatorRecv = new Promise((resolve) => {
    this.initiatorResolve = resolve;
  });
  private sendOnOpen: string[] = [];
  private lastPong?: Date;
  private pongInterval?: number;
  public onDisplayMessage: any;
  public onRTPace: any;
  public onRTFiller: any;

  private initiator = <any>{
    NewResults: true,
    Initiator: {},
    Format: "pcm",
    SampleRate: 16000,
  };

  constructor(callback: ResultsCallBack, format: string) {
    this.resultsCallback = callback;
    this.initiator.Format = format;
  }

  public Init(jwt: string, recordInit: RecordInitiator) {
    console.log("WS init");
    this.initiator.Initiator = recordInit;
    this.ws = new WebSocket(consts.wssurl + "session-ng" + "?authtoken=" + jwt);
    this.ws.binaryType = "blob";
    this.ws.onopen = () => {
      this.onOpen();
    };
    this.ws.onclose = (ev: CloseEvent) => {
      this.onClose(ev);
    };
    this.ws.onerror = (ev: Event) => {
      this.onError(ev);
    };
    this.ws.onmessage = (msg: MessageEvent) => {
      this.onMessage(msg);
    };
  }

  public setErrorCallback(cb: any) {
    this.onErrorCallback = cb;
  }

  public async OnInitiator(): Promise<any> {
    if (this.socketResponseInitiator) {
      return Promise.resolve(this.initiator);
    } else {
      return this.initiatorRecv;
    }
  }
  public async SendBinary(binary: any) {
    if (this.ws.readyState !== WebSocket.OPEN) {
      return;
    }
    if (this.socketResponseInitiator) {
      // const arrayBuffer = await new Response(blob).arrayBuffer();
      this.ws.send(binary);
    }
  }

  public SendEndOfAudio() {
    if (this.ws.readyState !== WebSocket.OPEN) {
      return;
    }
    this.ws.send(JSON.stringify(stopMsg));
    console.log("End of Audio sent");
  }
  public SendCancel() {
    if (!this.ws) {
      return;
    }

    if (this.ws.readyState !== WebSocket.OPEN) {
      setTimeout(() => {
        this.SendCancel();
      }, 1000);
      return;
    }
    this.ws.send(JSON.stringify(cancelMsg));
    console.log("Cancel message sent");
  }

  private onOpen(): any {
    console.log("onopen");

    let sendPing = () => {
      if (this.ws.readyState === WebSocket.OPEN) {
        this.ws.send("ping");
        setTimeout(sendPing, 1000);
      }
    };
    sendPing();

    this.pongInterval = window.setInterval(() => {
      let now = new Date();
      if (this.lastPong) {
        let diff: number = now.getTime() - this.lastPong.getTime();
        if (diff > 5000) {
          this.onError(new Event("ping pong timed out"));
          window.clearInterval(this.pongInterval);
          this.pongInterval = undefined;
        }
      }
    }, 1000);

    this.sendOnOpen.forEach((msg) => this.ws.send(msg));
    console.log("Initiator:" + JSON.stringify(this.initiator));
    this.ws.send(JSON.stringify(this.initiator));
  }

  private onMessage(msg: MessageEvent): any {
    if (msg.data === "pong") {
      this.lastPong = new Date();
      return;
    }

    const data = JSON.parse(msg.data);
    if ("ID" in data && "Duration" in data && data["Duration"] === null) {
      // this.readyToSendAudio = true;
      console.info("Got Initiator");
      this.initiatorResolve(data);
      this.socketResponseInitiator = data;
      console.log(data);
    } else if ("ID" in data && "Duration" in data && data["Duration"] > 0) {
      console.log("got results:");
      console.log(data);
      this.ws.close();
      this.resultsCallback(data);
    } else if ("channel" in data && data["channel"] == "webrtc") {
      if (this.onWebRTCMessage !== undefined) {
        this.onWebRTCMessage(data["payloadType"], data["payload"]);
      }
    } else if ("Type" in data && data["Type"] === "displayMessage") {
      if (this.onDisplayMessage) {
        this.onDisplayMessage(data["Data"]);
      }
    } else if ("Type" in data && data["Type"] === "RT-Pace") {
      if (this.onRTPace) {
        const pace: RTPace = data;
        this.onRTPace(pace);
      }
    } else if ("Type" in data && data["Type"] === "RT-Filler") {
      if (this.onRTFiller) {
        const rtFiller: RTFiller = data;
        this.onRTFiller(rtFiller);
      }
    } else {
      console.info("server message" + msg.data);
    }
  }

  public SendWebRTCMessage(msgType: string, msg: any) {
    let jsonMsg = JSON.stringify({
      channel: "webrtc",
      payloadType: msgType,
      payload: msg,
    });
    if (this.ws && this.ws.readyState === WebSocket.OPEN) {
      this.ws.send(jsonMsg);
    } else {
      this.sendOnOpen.push(jsonMsg);
    }
  }

  private onError(ev: Event): any {
    this.Close();
    console.error(ev);
    if (this.onErrorCallback) {
      this.onErrorCallback(ev);
    }
  }

  private onClose(ev: CloseEvent): any {
    console.log("WS:close");
    console.info(ev);
    if (this.pongInterval) {
      window.clearInterval(this.pongInterval);
    }
    //this is always coming up as false, resulting in that error
    if (ev.wasClean === false) {
      console.log("close was not clean");
      //this.onErrorCallback(ev);
    }
  }

  public Close() {
    if (!this.ws) {
      return;
    }

    if (
      this.ws.readyState !== WebSocket.CLOSED ||
      this.ws.readyState !== WebSocket.CLOSING
    ) {
      this.ws.close(1000);
    }
  }
}
